// **  Initial State
const initialState = {
  value: ''
}

const tempReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SetTempValue':
      return { ...state, value: action.payload.value }
    default:
      return state
  }
}

export default tempReducer
